import InputSelectField              from "components/form/fields/InputSelectField";
import InputMultipleSelectFieldLocal from "components/form/fields/InputMultipleSelectFieldLocal";
import { useFieldInfo }              from "contexts/FieldInfoContext";

const InputMultipleSelectField = (props) => {
  const { info } = useFieldInfo()

  if (info.numOptions < 100 && !info.isDepending)
    return <InputMultipleSelectFieldLocal {...props} />
  else
    return <InputSelectField {...props} selectProps={{mode: 'multiple', valueType: 'options'}} />
}

export default InputMultipleSelectField
